import {
	currentUserMeetsUserLevel,
	UserLevel,
} from '@netx/core-user-next/utils/currentUserMeetsUserLevel';
import {
	assetPermissionChecker,
	PermissionName,
	PermissionMatrixName,
} from '@netx/core-permissions-next';
import {type IAsset, AssetStatus} from '../schema';
import {assetNotCheckedOut} from './assetNotCheckedOut';

export const canCheckOut = (asset?: IAsset): boolean => {
	if (asset == null) return false;
	if (!currentUserMeetsUserLevel(UserLevel.PRODUCER)) return false;
	if (!assetNotCheckedOut(asset)) return false;
	if (
		![AssetStatus.NEARLINE, AssetStatus.ONLINE, AssetStatus.TEMP].includes(
			asset.status,
		)
	)
		return false;

	return assetPermissionChecker({
		asset,
		permissionMatrixName: PermissionMatrixName.MODIFY,
		permissionName: PermissionName.MANAGE_VERSIONS,
	});
};
